import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-3 py-3 text-right"
}
const _hoisted_2 = { class: "flex flex-wrap gap-3 flex-1 text-left" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "inline mt-2"
}
const _hoisted_5 = { class: "w-full p-4 border-round bg-white text-base" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "flex flex-row-reverse mt-4" }
const _hoisted_8 = { class: "w-full p-4 border-round bg-white text-base" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "flex flex-row-reverse mt-4" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "flex-1 flex" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = {
  key: 0,
  class: "flex-1 flex w-full"
}
const _hoisted_15 = { class: "flex w-4" }
const _hoisted_16 = { class: "flex w-full" }

import { computed, onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { useClipboard } from '@vueuse/core';
import Dialog from 'primevue/dialog';
import OrganizationReferralBuilderIntakeForm from './OrganizationReferralBuilderIntakeForm.vue';
import { useOrganizationReferralBuilderStore } from '@/store';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationReferralBuilder',
  setup(__props) {

const organizationReferralBuilderStore = useOrganizationReferralBuilderStore();

const {
  referralBuilderSettings,
  referralBuilderSettingsId,
  referralBuilderSettingsLoading,
  referralCode,
  referralCodeError,
  referralFormId,
  referralFormCodeModal,
  referralFormLinkModal,
  referralFormPreviewModal,
  source,
} = storeToRefs(organizationReferralBuilderStore);

onBeforeMount(() => organizationReferralBuilderStore.getReferralBuilderSettings());

const referralCodeLink = computed(() => `${window.location.origin}/referral/intake?code=${referralFormId.value}`);

const referralFormCode = computed(
  () =>
    '<iframe src="' +
    referralCodeLink.value +
    '" width="100%" height="1055" frameborder="0" marginheight="0" marginwidth="0"></iframe>',
);

const { copied, copy } = useClipboard({ source });

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (!_unref(referralBuilderSettingsLoading))
    ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
        content: _withCtx(() => [
          (_unref(can)([_unref(PERMISSIONS).REFERRAL_BUILDER_STORE]))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Icon, {
                      name: "info",
                      class: "mt-1 text-primary text-xl"
                    })
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex flex-1" }, [
                    _createElementVNode("span", { textContent: 
                'To build your Referral page, please select the additional data you want to include. You can also choose whether this data should be required. Note that the initial set of data is always included and required for referrals.'
               })
                  ], -1))
                ]),
                (_unref(referralFormId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "copy",
                        class: "px-2 text-grey text-xl cursor-pointer",
                        onClick: _unref(organizationReferralBuilderStore).onReferralFormCodeModal
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          'Referral Form Code',
                          void 0,
                          { top: true }
                        ]
                      ]),
                      _createVNode(_unref(Dialog), {
                        visible: _unref(referralFormCodeModal),
                        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(referralFormCodeModal) ? (referralFormCodeModal).value = $event : null)),
                        modal: "",
                        header: "Referral Form Code",
                        style: { width: '50rem' }
                      }, {
                        default: _withCtx(() => [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-full pb-3 text-md text-primary font-semibold" }, " You can add this form to an existing webpage by editing the webpage and pasting this code in the desired position on the page. ", -1)),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", {
                              textContent: _toDisplayString(referralFormCode.value)
                            }, null, 8, _hoisted_6)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_AppButton, {
                              type: "primary",
                              text: _unref(copied) ? 'Copied' : 'Copy Code',
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copy)(referralFormCode.value)))
                            }, null, 8, ["text"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible"]),
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "link",
                        class: "px-2 text-grey text-xl cursor-pointer",
                        onClick: _unref(organizationReferralBuilderStore).onReferralFormLinkModal
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          'Referral Form Link',
                          void 0,
                          { top: true }
                        ]
                      ]),
                      _createVNode(_unref(Dialog), {
                        visible: _unref(referralFormLinkModal),
                        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(referralFormLinkModal) ? (referralFormLinkModal).value = $event : null)),
                        modal: "",
                        header: "Referral Form Link",
                        style: { width: '50rem' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", {
                              textContent: _toDisplayString(referralCodeLink.value)
                            }, null, 8, _hoisted_9)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_AppButton, {
                              type: "primary",
                              text: _unref(copied) ? 'Copied' : 'Copy Link',
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(copy)(referralCodeLink.value)))
                            }, null, 8, ["text"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible"]),
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "visibility",
                        class: "px-2 text-grey text-xl cursor-pointer",
                        onClick: _unref(organizationReferralBuilderStore).onReferralFormPreviewModal
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          'Preview Referral Form',
                          void 0,
                          { top: true }
                        ]
                      ]),
                      _createVNode(_unref(Dialog), {
                        visible: _unref(referralFormPreviewModal),
                        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_isRef(referralFormPreviewModal) ? (referralFormPreviewModal).value = $event : null)),
                        modal: "",
                        header: "Referral Form Preview",
                        style: { width: '50rem' }
                      }, {
                        default: _withCtx(() => [
                          (_unref(referralFormId))
                            ? (_openBlock(), _createBlock(OrganizationReferralBuilderIntakeForm, {
                                key: 0,
                                "referral-form-id": _unref(referralFormId),
                                "is-preview": true
                              }, null, 8, ["referral-form-id"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["visible"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(referralFormId))
                  ? (_openBlock(), _createBlock(_component_AppButton, {
                      key: 1,
                      type: "secondary",
                      text: "Cancel",
                      onClick: _unref(organizationReferralBuilderStore).onReferralBuilderCancel
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_AppButton, {
                  type: "primary",
                  text: `${!_unref(referralBuilderSettingsId) ? 'Create' : 'Update'} Settings`,
                  onClick: _unref(organizationReferralBuilderStore).onReferralBuilderSave
                }, null, 8, ["text", "onClick"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataTable, { value: _unref(referralBuilderSettings) }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "label",
                header: "Display Label",
                "header-class": "w-8"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`font-semibold text-primary ${data.label === 'Referral Code' ? 'mt-2' : ''}`),
                        textContent: _toDisplayString(data.label)
                      }, null, 10, _hoisted_13)
                    ]),
                    (data.label === 'Referral Code')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", {
                              class: "mt-2 mr-2 inline-block text-primary hover:underline",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(organizationReferralBuilderStore).onGenerateReferralCode && _unref(organizationReferralBuilderStore).onGenerateReferralCode(...args)))
                            }, " Generate Code ")
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_InputText, {
                              id: data.id,
                              modelValue: _unref(referralCode),
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(referralCode) ? (referralCode).value = $event : null)),
                              disabled: data.disabled,
                              type: "text",
                              placeholder: "Enter or Generate a Custom Referral Code",
                              class: _normalizeClass(`w-full relative ${_unref(referralCodeError) ? 'p-invalid' : ''}`)
                            }, null, 8, ["id", "modelValue", "disabled", "class"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "include",
                header: "Include"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_InputSwitch, {
                    id: data.id,
                    modelValue: data.include.enabled,
                    "onUpdate:modelValue": ($event: any) => ((data.include.enabled) = $event),
                    disabled: data.include.disabled,
                    class: "ml-1",
                    onChange: ($event: any) => (_unref(organizationReferralBuilderStore).onIncludeChange(data.id))
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "required",
                header: "Required"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_InputSwitch, {
                    id: data.id,
                    modelValue: data.required.enabled,
                    "onUpdate:modelValue": ($event: any) => ((data.required.enabled) = $event),
                    disabled: data.required.disabled,
                    class: "ml-1",
                    onChange: ($event: any) => (_unref(organizationReferralBuilderStore).onRequiredChange(data.id))
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})